/**
 * Type definitions for React Router navigation state
 */

/**
 * Location state for tracking where the user came from
 * Used by authentication flow to redirect after login
 */
export interface LocationState {
  from?: {
    pathname: string;
  };
}

/**
 * Type guard to check if an object is a valid LocationState
 */
export function isLocationState(state: unknown): state is LocationState {
  if (state === null || typeof state !== 'object') {
    return false;
  }
  const s = state as Record<string, unknown>;
  if (s.from === undefined) {
    return true; // from is optional
  }
  if (typeof s.from !== 'object' || s.from === null) {
    return false;
  }
  const from = s.from as Record<string, unknown>;
  return typeof from.pathname === 'string';
}

/**
 * Safely extract the redirect path from location state
 * @param state - The location state from react-router
 * @param defaultPath - Default path if state is invalid
 * @returns The pathname to redirect to
 */
export function getRedirectPath(state: unknown, defaultPath: string = '/dashboard'): string {
  if (isLocationState(state) && state.from?.pathname) {
    return state.from.pathname;
  }
  return defaultPath;
}
